export enum ConnectionType {
	Usb = 'Usb',
	Lan = 'Lan',
}
